































// @ts-nocheck
import { Component, Vue,  Watch } from 'vue-property-decorator'
import { DataStore, Hub } from 'aws-amplify'
import Editor from '@/components/Editor.vue'
import { RowConfig } from '@/lib/RowConfig.interface'
import { GenerateLocaleDict } from '../lib/Locale'
import { mutateSnackbar } from '@/store/snackbar'
import { ChecklistItem } from '../models/index'
import { copyFromDataStore, HubEvents } from '@/amplify'

@Component<DistrictChecklistItemEditView>({
  components: {
    Editor
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('itemEdit.title')
    }
  },
})
export default class DistrictChecklistItemEditView extends Vue {
  item = null
  isLoading = false
  isPreviewVisible = false

  @Watch('itemId', { immediate: true })
  refetchItem() {
    this.getChecklistItem()
  }

  async getChecklistItem() {
    this.isLoading = true
    try {
      const query = await DataStore.query(ChecklistItem, this.itemId)
      if (!query) throw new Error('Page not found')
      this.item = copyFromDataStore(query)
      if(!this.item.contentDetail) {
        this.item.contentDetail = {
          what: GenerateLocaleDict(),
          when: GenerateLocaleDict(),
          where: GenerateLocaleDict(),
          infoText: GenerateLocaleDict(),
          information: GenerateLocaleDict(),
          documents: GenerateLocaleDict(),
        }
      }
      if(!this.item.contentList) {
        this.item.contentList = {
          what: GenerateLocaleDict(),
          when: GenerateLocaleDict(),
          where: GenerateLocaleDict(),
        }
      }
      for (const [key, value] of Object.entries(this.item.contentDetail)) {
        if(!value) {
          this.item.contentDetail[key] = GenerateLocaleDict()
        }
      }
      for (const [key, value] of Object.entries(this.item.contentList)) {
        if(!value) {
          this.item.contentList[key] = GenerateLocaleDict()
        }
      }
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    this.isLoading = false
  }

  get editorRows(): RowConfig[] {
    return [
      {
        title: this.$t('itemEdit.listWhat'),
        type: 'title',
        key: 'contentList.what'
      },
      {
        title: this.$t('itemEdit.listWhen'),
        type: 'title',
        key: 'contentList.when'
      },
      {
        title: this.$t('itemEdit.listWhere'),
        type: 'title',
        key: 'contentList.where'
      },
      {
        title: this.$t('itemEdit.detailWhat'),
        type: 'text',
        key: 'contentDetail.what'
      },
      {
        title: this.$t('itemEdit.detailInformation'),
        type: 'text',
        key: 'contentDetail.information'
      },
      {
        title: this.$t('itemEdit.detailWhen'),
        type: 'text',
        key: 'contentDetail.when'
      },
      {
        title: this.$t('itemEdit.detailWhere'),
        type: 'text',
        key: 'contentDetail.where'
      },
      {
        title: this.$t('itemEdit.detailDocuments'),
        type: 'text',
        key: 'contentDetail.documents'
      }
    ]
  }
  get reminderDayOptions() {
    return [
      {
        value: 'before',
        text: this.$t('itemEdit.beforeBirth')
      },
      {
        value: 'after',
        text: this.$t('itemEdit.afterBirth')
      }
    ]
  }

  get reminderDayOption() {
    if (this.item == null) return 'after'
    return Math.abs(this.item.date.reminderDay) > this.item.date.reminderDay
      ? 'before'
      : 'after'
  }

  get reminderDay() {
    if (this.item == null) return 0
    return Math.abs(this.item.date.reminderDay)
  }

  get itemId() {
    return this.$route.params.itemId
  }

  async saveItem() {
    this.isLoading = true
    try {
      await DataStore.save(
        ChecklistItem.copyOf(
          await DataStore.query(ChecklistItem, this.itemId),
          updated => {
            for (const [key, value] of Object.entries(this.item)) {
              updated[key] = value
            }
          }
        )
      )
      mutateSnackbar(
        { text: String(`Erfolgreich gespeichert`), color: `success` },
        this.$apollo
      )
    } catch (err) {
      mutateSnackbar({ text: err, color: `error` }, this.$apollo)
    }
    Hub.dispatch('ListEdit', {
      event: HubEvents.itemUpdate,
      data: {
        model: 'Checklist',
      }
    })
    this.isLoading = false
  }

  reminderDayOptionChange(value: 'before' | 'after') {
    if (this.item == null) return
    this.item.date.reminderDay =
      value === 'before'
        ? -Math.abs(this.item.date.reminderDay)
        : Math.abs(this.item.date.reminderDay)
  }

  reminderDayChange(value: number) {
    if (this.item == null) return
    this.item.date.reminderDay =
      this.reminderDayOption === 'before' ? -Math.abs(value) : Math.abs(value)
  }
}
